<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-user-points">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4 mainContainer">
            <h4>User Manager</h4>
            <hr />
            <div v-if="showForm">
              <div class="row mt-1">
                <div class="col-sm-6 col-md-6">
                  <b-input-group prepend="Name">
                    <b-form-input
                      placeholder="Test"
                      :value="userDetail.name"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                </div>
                <div class="col-sm-6 col-md-6">
                  <b-input-group prepend="User Name">
                    <b-form-input
                      :value="userDetail.username"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                </div>
              </div>
              <br />
              <h6>Add / Subtract User Points</h6>
              <br />
              <p>*These fields are required</p>
              <b-form @submit="submitPointsForm">
                <div class="row mt-3">
                  <div class="col-sm-4 col-md-4">
                    <div class="row">
                      <div class="col-sm-2 col-md-2">
                        <p>Type*</p>
                      </div>
                      <div class="col-sm-10 col-md-10">
                        <b-form-select
                          :options="TypeOptions"
                          v-model="pointsForm.type"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4 col-md-4">
                    <b-input-group prepend="Points*">
                      <b-form-input
                        type="number"
                        v-model="pointsForm.points"
                        required
                        min="1"
                      />
                    </b-input-group>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-sm-12 col-md-12">
                    <p>Why are these points being added? *</p>
                    <b-form-textarea
                      id="textarea"
                      placeholder="Enter something..."
                      rows="3"
                      max-rows="6"
                      required
                      v-model="pointsForm.comment"
                    />
                  </div>
                </div>
                <!--<div v-if="stripeCustomerId">
                  <strong
                    >When adding points you will be charged the following amount
                    using the payment method on file:</strong>
                  <div
                    v-if="
                      pointsForm.points > 0 && pointsForm.type == 'points added'
                    "
                  >
                    <h4>Price: ${{ pointsForm.points / ratio }}</h4>
                    <h4>
                      Unallocated Points that will be added: ${{ unallocDeposit }}
                    </h4>
                    <h4>Total: ${{(pointsForm.points / ratio) - unallocDeposit >= 0 ? ((pointsForm.points / ratio) - unallocDeposit).toFixed(2) : 0}}</h4>
                  </div>
                  <h4 v-else>$0</h4>
                </div>-->
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn btn-primary btn-lg btn-sm-block mt-3"
                  :disabled="loading"
                >
                  Add Points
                </b-button>
                 <b-spinner v-show="loading" variant="primary" label="Spinning"></b-spinner>
              </b-form>
              <p v-if="errorMessage" class="m-3 text-danger font-weight-bolder">
                ERROR: {{ errorMessage }}
              </p>
            </div>
            <div v-else>
              <h6>Points Updated Successfully</h6>
              <router-link
                type="submit"
                variant="primary"
                class="btn btn-primary btn-lg btn-sm-block mt-3"
                :to="{
                  name: 'AdminUserManager',
                  params: {
                    activeMenuItem: 'usersUserManager',
                    activeMenu: 'users',
                  },
                }"
              >
                User Manager
              </router-link>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import { mapState } from "vuex";
import { ChargeAndAllocate } from "@/api/funding";

export default {
  name: "AdminUserManagerPoints",
  props: {
    userId: Number,
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
  },
  data() {
    return {
      pointsForm: {
        points: null,
        comment: "",
        type: null,
      },
      showForm: true,
      TypeOptions: [
        {
          value: null,
          text: "Select An Option",
        },
        {
          value: "points added",
          text: "Add Points",
        },
        {
          value: "points subtract",
          text: "Subtract Points",
        },
      ],
      errorMessage: "",
      loading: false,
    };
  },
  async created() {
    await this.$store.dispatch("userManager/fetchUserDetailsById", {
      userId: this.userId,
    });
    await this.$store.dispatch("company/fetchCompany"); // TODO all of these things should be persistent
    await this.$store.dispatch("user/fetchProfile");
  },
  destroyed() {
    if (this.$route.name === "AdminUserManager") {
    } else {
      this.$store.commit("userManager/SET_FILTER_DATA_FOR_USER_MANAGER", {
        companyId: 0,
        userType: 0,
        status: 2,
        recordsPerScreen: 5,
        search: "",
      });
    }
  },
  computed: {
    ...mapState({
      userDetail: (state) => state.userManager.userDetail,
      companyName: (state) => state.company.name,
      stripeCustomerId: (state) => state.company.stripeCustomerId,
      ratio: (state) => state.company.ratio,
      userClients: (state) => state.user.userClients,
      loggedInUserID: (state) => state.user.profile.id,
      userEmail: (state) => state.user.email,
      unallocDeposit: (state) => state.company.unallocDeposit,
    }),
  },
  methods: {
    async submitPointsForm(event) {
      event.preventDefault();
      this.loading = true;
      this.errorMessage = ""; // reset the error message string
      /*if (
        this.stripeCustomerId &&
        this.pointsForm.points > 0 &&
        this.pointsForm.type == "points added"
      ) {
        try {
          const payload = {
            clientID: parseInt(this.userClients.client),
            receiptEmail: this.userEmail,
            description: this.pointsForm.comment,
            byWhom: this.loggedInUserID,
            points: parseFloat(this.pointsForm.points),
          };
          const resp = await ChargeAndAllocate(payload);
          console.log(resp);

          if (resp.status != 200) {
            console.error("did not return 200");
            this.errorMessage = resp.data;
            return;
          }
        } catch (e) {
          console.error(
            `something went wrong allocating points and charging customer. ${e}`
          );
          this.errorMessage = e;
          this.loading = false;
          return;
        }
      }*/

      try {
        await this.$store.dispatch("userManager/updateUserPoints", {
          ...this.pointsForm,
          user_id: this.userId,
          points: +this.pointsForm.points,
        });
        this.showForm = false;
      } catch (e) {
        console.error(`something went wrong adding points to user in db. ${e}`);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-user-points {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.mainContainer {
  margin-top: 7%;
}
</style>
